import toast, { Toaster } from 'react-hot-toast';

export const notify = (status, msg) => {
    if (status) {
        toast.success(msg)
    }
    else {
        toast.error(msg)
    }
}